import { motion } from "framer-motion";
import { ASSETS, RERA } from "@/lib/constants";

export const About = () => {
  return (
    <section id="about" className="relative py-24 md:py-32 overflow-hidden" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Text */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="lg:col-span-6 order-2 lg:order-1"
          >
            {/* <div className="text-xs uppercase tracking-[0.4em] text-[#D4AF37] mb-5 section-mark">About the project</div> */}
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#F8F6F0] leading-[1.05] tracking-tight">
              A Landmark for{" "}
              {/* <span className="block italic gold-text-dark">ambition.</span> */}
              <span className="italic bg-gradient-to-r from-[#ffb413] via-[#D4AF37] to-[#ff9900] text-transparent bg-clip-text">
              Leaders.
            </span>
            </h2>
            <p className="mt-8 text-base md:text-lg text-[#A0A0A0] leading-relaxed max-w-xl font-light">
              Palaash Paradise rises at the heart of Nigdi Pradhikaran, a meticulously
              crafted address for premium showrooms and offices. Every facet of the
              architecture is composed to elevate the businesses it shelters, and to be
              remembered by every visitor who arrives.
            </p>

            <div className="mt-10 grid grid-cols-2 gap-6 max-w-md">
              <div className="border-l border-[#D4AF37]/40 pl-4">
                <div className="text-[10px] uppercase tracking-[0.3em] text-[#A0A0A0]">Project By</div>
                <div className="font-serif text-xl md:text-2xl text-[#F8F6F0] mt-1">Prachi Infra</div>
              </div>
              <div className="border-l border-[#D4AF37]/40 pl-4">
                <div className="text-[10px] uppercase tracking-[0.3em] text-[#A0A0A0]">MahaRERA</div>
                <div className="font-mono text-sm md:text-base text-[#D4AF37] mt-1">{RERA}</div>
              </div>
            </div>

            {/* Download Brochure Button - Centered on Mobile, Left on Desktop */}
            <div className="mt-8 flex justify-center md:justify-start">
              <motion.a
                href={ASSETS.brochure}
                download
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.97 }}
                className="inline-flex items-center gap-3 px-6 sm:px-8 py-3.5 sm:py-4 bg-[#D4AF37] text-[#050505] font-semibold text-xs sm:text-sm uppercase tracking-[0.15em] hover:bg-[#C5A035] transition-colors duration-300 w-auto min-w-[200px] sm:min-w-0 justify-center"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="sm:w-[18px] sm:h-[18px]"
                >
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                Download Brochure
              </motion.a>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
            className="lg:col-span-6 order-1 lg:order-2 relative"
          >
            <div className="relative aspect-[4/5] md:aspect-square overflow-hidden border border-[#D4AF37]/20">
              <img
                src={ASSETS.building}
                alt="Palaash Paradise — exterior rendering"
                className="w-full h-full object-cover"
                data-testid="about-building-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent opacity-70" />
              <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between">
                <div>
                  <div className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]">Artistic Impression</div>
                  <div className="font-serif text-2xl text-[#F8F6F0] mt-1">Palaash Paradise</div>
                </div>
                <div className="text-right">
                  <div className="text-[10px] uppercase tracking-[0.3em] text-[#A0A0A0]">Nigdi</div>
                  <div className="text-xs text-[#F8F6F0]">Pune</div>
                </div>
              </div>
            </div>
            {/* Decorative corner */}
            <div className="absolute -top-4 -left-4 w-16 h-16 border-t border-l border-[#D4AF37]/60" />
            <div className="absolute -bottom-4 -right-4 w-16 h-16 border-b border-r border-[#D4AF37]/60" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};